<div class="saved-seguridata-container col-10">
  <div>
    <div class="seguridata-details" *ngIf="seguridataFormId">
        <img src="https://stecmexprod002.blob.core.windows.net/sitefinity/images/default-source/corporate-site/sna-icons/success-icon.png?sfvrsn=709193ec_1" 
        class="seguridata-icon"/>

        <h3 class="seguridata-title">
          <span i18n>Agreement Signed Successfully</span>
        </h3>
      
        <p class="seguridata-text">
          <span i18n>Your Seguridata digital signature confirmation number is:</span>
          <strong class="seguridata-id">
            {{ seguridataFormId }}
          </strong>
        </p>
    </div>
  </div>
</div>
